import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { StopCollector } from './stop-collector';
import { LeafletStop } from '../core/stop';

@Component({
    selector: 'search-stop-input',
    templateUrl: 'search-stop.component.html',
    styleUrls: ['./search-stop.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchStopComponent),
            multi: true
        }
    ]
})
export class SearchStopComponent implements OnInit, ControlValueAccessor {
    private substrings = new Subject<string>();
    private propagateChange = (obj: any) => { };
    private onTouched = (obj: any) => { };

    suggestedStops: Observable<LeafletStop[]>;
    isActivated: boolean = false;
    selectedStop: LeafletStop;
    get selectedStopName(): string {
        if (!this.selectedStop)
            return '';
        else
            return this.selectedStop.name;
    }
    set selectedStopName(value: string) {
        //workaround solution
    }

    @Input() theme: string = '';

    constructor(private stopCollector: StopCollector) { }

    //#region ControlValueAccessor implementation
    writeValue(value: any): void {
        this.selectedStop = value;
    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        throw new Error("Method not implemented.");
    }
    //#endregion

    ngOnInit() {
        this.suggestedStops = this.substrings.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap(substring => this.stopCollector.search(substring)));
    }

    search(substring: string) {
        this.substrings.next(substring);
    }

    leaveSearch() {
        setTimeout(() => {
            this.isActivated = false;
        }, 200);
    }

    select(stop: LeafletStop) {
        this.selectedStop = stop;
        this.propagateChange(this.selectedStop);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/search-stop.component.ts